/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages, check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage -- Strings intentionally do not start with the experiment package name in case this code needs to be productionized */
import { defineMessages } from 'react-intl';

export const messages: {
	// Greeting headings
	welcomeTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nicelyDoneTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Greeting subtitles
	welcomeSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nicelyDoneSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Intent picker — Path A
	intentStartCreatingLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	intentStartCreatingSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Intent picker — Path A (AIFC variant)
	intentKeepMomentumLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	intentKeepMomentumSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Intent picker — Path B
	intentSetUpSpaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	intentSetUpSpaceSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Content type labels (used as {contentType} values in prompt strings)
	contentTypeDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentTypeWhiteboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentTypeDatabase: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Path A — Land / Skipped AIFC prompts
	createSomethingNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createFromFile: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createDocFromFile: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createFromTemplate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Path A — Land / AIFC prompts
	turnContentTypeIntoContentType: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	turnContentTypeIntoKnowledgeHub: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	turnContentTypeIntoActionItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Path A — Xflow prompts
	writeStatusUpdate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	breakDownIssue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	breakDownIssueLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createScopeDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createScopeDocLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Path B — Land prompts
	createSpace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	setUpSitePermissions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectYourTools: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Input placeholder
	inputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Path B — Xflow prompts
	buildKnowledgeHub: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// Greeting headings
	welcomeTitle: {
		id: 'rovo-onboarding.welcome.title',
		defaultMessage: 'Welcome to Confluence!',
		description:
			'Greeting heading shown in the Rovo chat panel when a new user first lands in Confluence',
	},
	nicelyDoneTitle: {
		id: 'rovo-onboarding.nicely-done.title',
		defaultMessage: "Nicely done! What's next?",
		description:
			'Greeting heading shown in the Rovo chat panel after a user has created content through the AI-first create flow',
	},

	// Greeting subtitles
	welcomeSubtitle: {
		id: 'rovo-onboarding.welcome.subtitle',
		defaultMessage: 'Create something new or set up your space',
		description:
			'Subtitle shown below the welcome greeting heading in the Rovo chat panel for users who skipped the AI-first create flow',
	},
	nicelyDoneSubtitle: {
		id: 'rovo-onboarding.nicely-done.subtitle',
		defaultMessage: 'Pick up where you left off or set up a space',
		description:
			'Subtitle shown below the greeting heading in the Rovo chat panel for users who completed the AI-first create flow',
	},

	// Intent picker — Path A
	intentStartCreatingLabel: {
		id: 'rovo-onboarding.intent.start-creating.label',
		defaultMessage: 'Start creating',
		description:
			'Label for the "Start creating" intent picker card in the Rovo onboarding flow (Path A)',
	},
	intentStartCreatingSubtitle: {
		id: 'rovo-onboarding.intent.start-creating.subtitle',
		defaultMessage: 'Turn ideas into docs, whiteboards, and more',
		description:
			'Subtitle for the "Start creating" intent picker card in the Rovo onboarding flow (Path A)',
	},

	// Intent picker — Path A (AIFC variant)
	intentKeepMomentumLabel: {
		id: 'rovo-onboarding.intent.keep-momentum.label',
		defaultMessage: 'Keep the momentum going',
		description:
			'Label for the Path A intent picker card shown to users who created content through the AI-first create flow',
	},
	intentKeepMomentumSubtitle: {
		id: 'rovo-onboarding.intent.keep-momentum.subtitle',
		defaultMessage: 'Build on your work or create something new',
		description:
			'Subtitle for the Path A intent picker card shown to users who created content through the AI-first create flow',
	},

	// Intent picker — Path B
	intentSetUpSpaceLabel: {
		id: 'rovo-onboarding.intent.set-up-space.label',
		defaultMessage: 'Set up my space',
		description:
			'Label for the "Set up my space" intent picker card in the Rovo onboarding flow (Path B)',
	},
	intentSetUpSpaceSubtitle: {
		id: 'rovo-onboarding.intent.set-up-space.subtitle',
		defaultMessage: 'Configure permissions and connect tools',
		description:
			'Subtitle for the "Set up my space" intent picker card in the Rovo onboarding flow (Path B)',
	},

	// Content type labels (used as {contentType} values in prompt strings)
	contentTypeDoc: {
		id: 'rovo-onboarding.content-type.doc',
		defaultMessage: 'doc',
		description:
			'Content type label for a Confluence page/document, used as a substitution value in prompt strings',
	},
	contentTypeWhiteboard: {
		id: 'rovo-onboarding.content-type.whiteboard',
		defaultMessage: 'whiteboard',
		description:
			'Content type label for a Confluence whiteboard, used as a substitution value in prompt strings',
	},
	contentTypeDatabase: {
		id: 'rovo-onboarding.content-type.database',
		defaultMessage: 'database',
		description:
			'Content type label for a Confluence database, used as a substitution value in prompt strings',
	},

	// Path A — Land / Skipped AIFC prompts
	createSomethingNew: {
		id: 'rovo-onboarding.prompt.create-something-new',
		defaultMessage: 'Create something new',
		description: 'Prompt action label — opens the content creation flow from Rovo onboarding',
	},
	createFromFile: {
		id: 'rovo-onboarding.prompt.create-from-file',
		defaultMessage: 'Create from a file',
		description: 'Prompt action label — lets the user import a file to create Confluence content',
	},
	createDocFromFile: {
		id: 'rovo-onboarding.prompt.create-doc-from-file',
		defaultMessage: 'Create a doc from this file',
		description:
			'AI-generative prompt — pre-filled into the Rovo chat input when the user uploads a file via the "Create from a file" onboarding action, instructing the assistant to create a Confluence doc from the uploaded file',
	},
	createFromTemplate: {
		id: 'rovo-onboarding.prompt.create-from-template',
		defaultMessage: 'Create from a template',
		description:
			'Prompt action label — opens the template gallery for the user to start from a template',
	},

	// Path A — Land / AIFC prompts
	turnContentTypeIntoContentType: {
		id: 'rovo-onboarding.prompt.turn-content-type-into-content-type',
		defaultMessage: 'Turn this {sourceContentType} into a {outputContentType}',
		description:
			'AI-generative prompt — converts the current content into a different content type. {sourceContentType} is the type of content being converted (e.g. "whiteboard"), and {outputContentType} is the target type (e.g. "doc").',
	},
	turnContentTypeIntoKnowledgeHub: {
		id: 'rovo-onboarding.prompt.turn-content-type-into-knowledge-hub',
		defaultMessage: 'Turn this {contentType} into a knowledge hub',
		description:
			'AI-generative prompt — converts the current content into a structured knowledge hub. {contentType} is the type of content, e.g. "doc", "whiteboard", or "database".',
	},
	turnContentTypeIntoActionItems: {
		id: 'rovo-onboarding.prompt.turn-content-type-into-action-items',
		defaultMessage: 'Turn this {contentType} into action items',
		description:
			'AI-generative prompt — extracts action items from the current content. {contentType} is the type of content, e.g. "doc", "whiteboard", or "database".',
	},

	// Path A — Xflow prompts
	writeStatusUpdate: {
		id: 'rovo-onboarding.prompt.write-status-update',
		defaultMessage: 'Write a status update for {projectName}',
		description:
			'AI-generative prompt — creates a status update page for the linked Jira project. {projectName} is the name of the Jira project.',
	},
	breakDownIssue: {
		id: 'rovo-onboarding.prompt.break-down-issue',
		defaultMessage: 'Break down {issueKey}: {issueSummary} into next steps',
		description:
			'AI-generative prompt — breaks a Jira issue into actionable next steps. {issueKey} is the Jira issue key (e.g. "PROJ-123") and {issueSummary} is the issue title.',
	},
	breakDownIssueLink: {
		id: 'rovo-onboarding.prompt.break-down-issue-link',
		defaultMessage: 'Break down {issueLink} into next steps',
		description:
			'AI-generative prompt — breaks a Jira issue into actionable next steps. {issueLink} is a hyperlink to the Jira issue, with the issue key and summary as the link text.',
	},
	createScopeDoc: {
		id: 'rovo-onboarding.prompt.create-scope-doc',
		defaultMessage: 'Create a scope doc for {issueKey}: {issueSummary}',
		description:
			'AI-generative prompt — creates a scope/requirements document for a Jira issue. {issueKey} is the Jira issue key (e.g. "PROJ-123") and {issueSummary} is the issue title.',
	},
	createScopeDocLink: {
		id: 'rovo-onboarding.prompt.create-scope-doc-link',
		defaultMessage: 'Create a scope doc for {issueLink}',
		description:
			'AI-generative prompt — creates a scope/requirements document for a Jira issue. {issueLink} is a hyperlink to the Jira issue, with the issue key and summary as the link text.',
	},

	// Path B — Land prompts
	createSpace: {
		id: 'rovo-onboarding.prompt.create-space',
		defaultMessage: 'Create a space',
		description: 'Navigation prompt — opens the Create Space flow in Confluence',
	},
	setUpSitePermissions: {
		id: 'rovo-onboarding.prompt.set-up-site-permissions',
		defaultMessage: 'Set up site permissions',
		description: 'Navigation prompt — opens the site permissions settings in AdminHub',
	},
	connectYourTools: {
		id: 'rovo-onboarding.prompt.connect-your-tools',
		defaultMessage: 'Connect your tools to Confluence',
		description:
			'Navigation prompt — opens the third-party integrations connection page in AdminHub',
	},

	// Input placeholder
	inputPlaceholder: {
		id: 'rovo-onboarding.input.placeholder',
		defaultMessage: 'None of these? Type something else to get started.',
		description:
			'Placeholder text shown in the Rovo chat input during the onboarding flow, prompting users to type their own message if none of the suggested prompts suit them.',
	},

	// Path B — Xflow prompts
	buildKnowledgeHub: {
		id: 'rovo-onboarding.prompt.build-knowledge-hub',
		defaultMessage: 'Build a knowledge hub for {projectName}',
		description:
			'AI-generative prompt — creates a knowledge hub for the linked Jira project. {projectName} is the name of the Jira project.',
	},
});
